import React from 'react';
import { Check, X } from 'lucide-react';
interface ProsConsBoxProps {
  pros: string[];
  cons: string[];
}
export function ProsConsBox({
  pros,
  cons
}: ProsConsBoxProps) {
  return <div className="grid md:grid-cols-2 gap-6 p-6 bg-white border border-[#E8E4DD] rounded-lg" data-id="element-179">
      <div data-id="element-180">
        <h4 className="font-semibold text-[#1A2332] mb-3 flex items-center gap-2" data-id="element-181">
          <Check className="w-5 h-5 text-green-600" data-id="element-182" />
          Pros
        </h4>
        <ul className="space-y-2" data-id="element-183">
          {pros.map((pro, index) => <li key={index} className="flex items-start gap-2 text-sm text-[#1A2332]/80" data-id="element-184">
              <span className="text-green-600 mt-0.5" data-id="element-185">•</span>
              <span data-id="element-186">{pro}</span>
            </li>)}
        </ul>
      </div>

      <div data-id="element-187">
        <h4 className="font-semibold text-[#1A2332] mb-3 flex items-center gap-2" data-id="element-188">
          <X className="w-5 h-5 text-red-600" data-id="element-189" />
          Cons
        </h4>
        <ul className="space-y-2" data-id="element-190">
          {cons.map((con, index) => <li key={index} className="flex items-start gap-2 text-sm text-[#1A2332]/80" data-id="element-191">
              <span className="text-red-600 mt-0.5" data-id="element-192">•</span>
              <span data-id="element-193">{con}</span>
            </li>)}
        </ul>
      </div>
    </div>;
}